import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { TemplateOfferingDetailsMeetingRoom } from "../template_offering_details_meeting_room";
import { useCoalitionSpaceAnalytics } from "./coalition-space_analytics";
import { generalInfo, partnerConfig } from "./coalition-space_partner_config";

const Theme = lazyWithRetry(() => import("./coalition-space_theme"));

const faqs = [
  {
    question: "Tell me more about your conference rooms",
    answer:
      "Need a private space to host an off-site meeting, live-streaming event, or video conference call? Our goal is to enhance your workday by creating spaces for you to connect online or in-person and get focused work done.",
  },
];

export function OfferingCoalitionSpaceMeetingRoom() {
  useCoalitionSpaceAnalytics();

  return (
    <Fragment>
      <Theme />
      <TemplateOfferingDetailsMeetingRoom
        showAddress
        showDirections
        partnerConfig={partnerConfig}
        data={{
          faqs,
          generalInfo,
        }}
      />
    </Fragment>
  );
}
